import { render, staticRenderFns } from "./supplierAccountNo.vue?vue&type=template&id=5af11d5a&scoped=true&"
import script from "./supplierAccountNo.vue?vue&type=script&lang=js&"
export * from "./supplierAccountNo.vue?vue&type=script&lang=js&"
import style0 from "./supplierAccountNo.vue?vue&type=style&index=0&id=5af11d5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af11d5a",
  null
  
)

export default component.exports